import { PacmanLoader } from "react-spinners"
import { Container } from "./styles"





const Loader = () => {
    return (

    <Container>
        <PacmanLoader color="#007AFF"/>
    </Container>


    )


}


export default Loader